/* @flow */

// $FlowFixMe
module.exports = require('./dist/post-robot'); // eslint-disable-line import/no-commonjs

// $FlowFixMe
module.exports.default = module.exports; // eslint-disable-line import/no-commonjs
